import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { iconeNavigation } from './iconesNavigation';

function estAdministrateur() {
  try {
    return JSON.parse(localStorage.getItem('role')) === 'ROLE_ADMINISTRATEUR';
  } catch {
    // localStorage vide ou valeur non parsable : on considère non-admin.
    return false;
  }
}

/**
 * Frame Figma "naviagtion_sur_icone_DR", ouvert par le logo_rond de l'entête.
 *
 * Les frames 259, 260 et 261 sont réservées aux administrateurs (Q6).
 * La frame 264 (Nouvelle simulation) a été ajoutée à la maquette après coup.
 * Le bouton de la page courante est désactivé.
 */
export default function NavigationIconeDR({ onFermer }) {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const admin = estAdministrateur();

  const entrees = [
    { frame: 257, label: 'Accueil', icone: 'icon_home', route: '/' },
    { frame: 263, label: 'Mes simulations', icone: 'icon_mes_simulations', route: '/simulations' },
    { frame: 264, label: 'Nouvelle simulation', icone: 'icon_plus', route: '/nouvellesimulation' },
    { frame: 258, label: 'Profil', icone: 'icon-profil', route: '/monprofil' },
    { frame: 259, label: 'DiagoRisk 2050 territoire', icone: 'icon_DR_territoire50', route: '/diagorisk2050', adminSeulement: true },
    { frame: 260, label: 'Colza robuste et zéro insecticide', icone: 'icon_colza_noir', route: '/colzaZI', adminSeulement: true },
    { frame: 261, label: 'Créer un compte', icone: 'icon_Creer_compte', route: '/inscription', adminSeulement: true },
    { frame: 262, label: 'Déconnexion', icone: 'icon-deconnexion', route: '/', deconnexion: true },
  ];

  function allerA(entree) {
    if (entree.deconnexion) {
      localStorage.clear();
    }
    onFermer?.();
    navigate(entree.route);
  }

  return (
    <div className="nav-icone-dr">
      {entrees
        .filter((entree) => !entree.adminSeulement || admin)
        .map((entree) => {
          // Le bouton de déconnexion pointe aussi vers '/', mais il doit rester
          // cliquable depuis l'accueil : on ne le désactive jamais.
          const surLaPage = !entree.deconnexion && pathname === entree.route;
          return (
            <button
              key={entree.frame}
              type="button"
              className="nav-icone-dr-bouton"
              onClick={() => allerA(entree)}
              disabled={surLaPage}
            >
              {iconeNavigation(entree.icone) && (
                <img src={iconeNavigation(entree.icone)} alt="" />
              )}
              <span>{entree.label}</span>
            </button>
          );
        })}
    </div>
  );
}
